/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useMemo, useState} from 'react';
import {
  Dimensions,
  DimensionValue,
  Image,
  Modal,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {connect} from 'react-redux';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import {getTypeContrat} from '../../../../common/utils/contrat';
import {TYPE_ASSURANCE_ID} from '../../../../data/constants/Assurance';
import {
  defaultContratRCVP,
  defaultContratScolaire,
  defaultVersion,
  detailContratDTO,
} from '../../../../data/constants/Contrats/detailContrat';
import {BREAKPOINT} from '../../../../data/constants/screen';
import {
  dateDdMmYyToMmDdYy,
  DateToddmmyyyyFormat,
  thousandSeparator,
} from '../../../../data/factory';
import {
  IData,
  IDetailContrat,
  IDisplay,
} from '../../../../data/types/interface/Contrats/detailContrat';
import {StackParams} from '../../../../data/types/navigation';
import {GeneratePdfServices} from '../../../../services/applicatif/generate_pdf';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {get} from '../../../../services/technique/api';
import {RegisterFonts} from '../../../components/AttestationExport/MonAttesation';
import {buttonsStyles} from '../../../components/Button/boutonStyle';
import PrimaryButton from '../../../components/Button/PrimaryButton';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import DateTimePickerWeb from '../../../components/Inputs/DatePicker/index.web';
import {formsStyles} from '../../../components/Inputs/formStyles';
import Label from '../../../components/Label';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {ProduitItem} from '../../../components/ProduitItem';
import {ContratRattacheForm} from '../ContratRattacher';
import styles from './styles';

type NavigationProps = StackNavigationProp<StackParams, 'DetailContrat'>;
type NavigationPropsGlossaire = StackNavigationProp<StackParams, 'Glossaire'>;

let versionDto = {
  dateEcheance: '',
  dateSouscription: '',
  numeroPolice: '',
  objetRisque: '',
  prime: 0,
  smp: 0,
};

let hideLoader = () => {};
let showLoader = () => {};
const {generatePDF} = GeneratePdfServices();

let typeContrat = '';
let titleContrat = '';
let dateMin = '';
let dateMax = '';

const DetailContratScreen = (props: any) => {
  let title =
    props && props.route && props.route.params && props.route.params.title;
  title = title && title.toUpperCase();
  const [detailContrat, setDetailContrat] =
    useState<IDetailContrat>(detailContratDTO);

  const numeroPolice = props?.route?.params?.numeroPolice;
  titleContrat = props?.route?.params?.title;
  const [isLoading, setLoader] = React.useState(true);
  const [dateContrat, setDateContrat] = useState('');
  const [agenceAro, setAgenceAro] = useState('');
  const [version, setVersion] = useState(defaultVersion);
  const [showRenouvellement, setShowRenouvellement] =
    React.useState<boolean>(false);
  const {getNumeroPoliceUser, contratEnCoursUser, user} = props;
  const {navigate} = useNavigation<NavigationProps>();
  const navigation = useNavigation<NavigationPropsGlossaire>();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const currentUser = user?.data?.utilisateur;

  useFocusEffect(() => {
    if (!currentUser) {
      navigate('Login', {
        data: 'MesContrats',
      });
    }
  });

  showLoader = () => {
    setLoader(true);
  };
  hideLoader = () => {
    setLoader(false);
  };

  const getDetailContrat = (
    numeroPolice: any,
    typeContrat: any,
    date?: any,
  ) => {
    get(
      'common/contrat/numero-police/?numeroPolice=' +
        numeroPolice +
        '&date=' +
        date,
    )
      .then(response => {
        if (response && response.data && !response.isError) {
          const dataToDisplay: IDetailContrat = response.data;
          dateMin =
            response.data && response.data.dateSouscription
              ? response.data.dateSouscription
              : new Date().getDate().toString() +
                '/' +
                (new Date().getMonth() + 1).toString() +
                '/' +
                new Date().getFullYear().toString();
          if (response.data && response.data.dateEcheance) {
            dateMax = response.data.dateEcheance;
          } else {
            dateMax =
              new Date().getDate().toString() +
              '/' +
              (new Date().getMonth() + 1).toString() +
              '/' +
              new Date().getFullYear().toString();
          }

          if (
            response.data &&
            response.data.versions &&
            response.data.versions.length > 0
          ) {
            setVersion(response.data.versions[0]);
            versionDto = {...versionDto, ...response.data.versions['0']};
          }

          setAgenceAro(dataToDisplay.agence);
          const detail: Partial<IDetailContrat> = {...dataToDisplay};
          if (dataToDisplay) {
            if (typeContrat === 'rcvp') {
              detail.typePayment = 'prime';
              detail.primeTTC = thousandSeparator(
                dataToDisplay.primeTTC !== undefined
                  ? dataToDisplay.primeTTC
                  : '',
                ' ',
              );
            } else if (typeContrat === 'retraite') {
              detail.typePayment = 'cotisation';
              detail.premierVersement = thousandSeparator(
                dataToDisplay.premierVersement !== undefined
                  ? dataToDisplay.premierVersement
                  : '',
                ' ',
              );
            } else if (typeContrat === 'scolaire') {
              detail.typePayment = 'prime';
              detail.primeTTC = thousandSeparator(
                dataToDisplay.primeTTC !== undefined
                  ? dataToDisplay.primeTTC
                  : '',
                ' ',
              );
            }

            setDetailContrat(prev => ({
              ...prev,
              numeroPolice,
              typeContratPayment: typeContrat,
              is_avenant: dataToDisplay.isAvenant,
              ...detail,
            }));
          }
        } else {
          console.log(response);
          if (response?.isError) {
            setShowErrorModal(() => true);
            setErrorMessage(() => response.message);
          }
        }
      })
      .catch(err => {
        console.log(err);
        setShowErrorModal(() => true);
        setErrorMessage(() => err.data.message);
      })
      .finally(() => {
        setLoader(() => false);
      });
  };

  const display = useMemo(() => {
    if (isLoading) {
      return {items: []};
    }
    const actions: Record<string, IData> = {
      avenant: {
        libelle: 'Demander avenant',
        destinationPage: 'DemanderAvenant',
        id: '1',
        imageUrl: 'edit-3.png',
      },
      attestation: {
        libelle: 'Mon attestation',
        isPdf: true,
        id: '1',
        destinationPage: 'MonAttestation',
        imageUrl: 'down-pdf.png',
        action: async () => {
          if (detailContrat.typeContratPayment && detailContrat.numeroPolice) {
            showLoader();

            generatePDF(
              detailContrat.numeroPolice,
              detailContrat.typeContratPayment,
            )
              .then(res => {
                const url = window.URL.createObjectURL(
                  new Blob([res], {type: 'application/pdf'}),
                );

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                  'download',
                  `${detailContrat.typeContratPayment}-${detailContrat.numeroPolice}-${detailContrat.nomPrenomContractant}.pdf`,
                );
                link.setAttribute('target', `_blank`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
              })
              .catch(error => console.log(error))
              .finally(() => {
                hideLoader();
              });
          }
        },
      },
      familleSinistre: {
        libelle: 'Déclarer Sinistre',
        destinationPage: 'FamilleSinistre',
        id: '1',
        imageUrl: 'shield-3.png',
      },
      autoMotoSinitre: {
        libelle: 'Déclarer Sinistre',
        destinationPage: 'AutoMotoSinistre',
        id: '1',
        imageUrl: 'shield-3.png',
      },
    };

    const data: IDisplay = {items: []};
    if (title.toUpperCase() === 'ASSURANCE RETRAITE') {
      data.items = [actions.avenant, actions.attestation];
    } else if (
      title.toUpperCase() === 'ASSURANCE SCOLAIRE' ||
      title.toUpperCase() === 'ASSURANCE RC VIE PRIVÉE'
    ) {
      data.items = [
        actions.avenant,
        actions.attestation,
        actions.familleSinistre,
      ];
    } else if (title.toUpperCase() === 'MONOVEHICULE') {
      data.items = [actions.attestation];

      if (
        dayjs(detailContrat.dateEcheance, 'DD/MM/YYYY').diff(
          dayjs(),
          'month',
          true,
        ) >= 1
      ) {
        data.items.unshift(actions.avenant);
      }
    } else {
      data.items = [];
    }

    return data;
  }, [detailContrat, isLoading]);

  const searchDate = () => {
    getDetailContrat(numeroPolice, getTypeContrat(titleContrat), dateContrat);
  };
  const changeDate = (value: any) => {
    setDateContrat(DateToddmmyyyyFormat(value));
  };

  React.useEffect(() => {
    RegisterFonts();

    typeContrat = getTypeContrat(titleContrat);

    if (props.route.params?.typeContrat) {
      typeContrat = props.route.params?.typeContrat;
    }

    getNumeroPoliceUser(numeroPolice, () => {});
    getDetailContrat(numeroPolice, typeContrat, '');
  }, [props.route.params]);

  const goToPayment = (type = '') => {
    if (type === 'renouvellement') {
      contratEnCoursUser({...detailContrat, typePayment: 'renouvellement'});
    } else {
      contratEnCoursUser(detailContrat);
    }
    navigate('Payement');
  };

  const onSubmitContratForm = () => {
    setShowRenouvellement(false);
    navigation.replace('Payement');
  };
  const handleRenouvelerContrat = async () => {
    const typeId = TYPE_ASSURANCE_ID[typeContrat];

    if (typeContrat == 'scolaire') {
      contratEnCoursUser({
        ...defaultContratScolaire,
        numeroPolice: detailContrat.numeroPolice,
      });
      navigation.replace('SouscriptionAssuranceScolaireForm', {
        montant: ' ',
        typeAssurance: 'renouvellement',
        typeId,
      });
    } else if (typeContrat == 'rcvp') {
      contratEnCoursUser({
        ...defaultContratRCVP,
        numeroPolice: detailContrat.numeroPolice,
      });
      navigation.replace('SouscriptionAssuranceRCVPForm', {
        typeAssurance: 'renouvellement',
        typeId,
      });
    } else {
      setShowRenouvellement(true);
    }
  };

  return (
    <View style={{flex: 1}}>
      <HeaderScreen type="retour" title="Détails contrat" />
      <View>
        <View style={formsStyles.webformContain}>
          <View
            style={[
              {
                paddingHorizontal:
                  Dimensions.get('window').width < BREAKPOINT.sm ? 20 : 40,

                maxWidth: 1025,
                width: '100%',
                paddingTop: 40,
                backgroundColor: 'white',
              },
            ]}>
            {detailContrat.is_ending &&
            !isLoading &&
            detailContrat.typeContratPayment !== 'retraite' ? (
              <View
                style={[
                  {
                    padding: 20,
                    backgroundColor: 'pink',
                    borderRadius: 10,
                  },
                ]}>
                <Text
                  style={{
                    color: '#16599c',
                    fontWeight: 'bold',
                  }}>{`${
                  detailContrat.is_recurrent
                    ? 'Reconduction tacite'
                    : 'Renouvelable après accord'
                }`}</Text>
                <Text
                  style={{
                    color: 'black',
                    marginTop: 10,
                  }}>{`POLICE N° ${numeroPolice}`}</Text>
                <Text
                  style={{
                    color: 'black',
                    marginTop: 10,
                  }}>{`Montant: ${detailContrat.primeTTC}Ar`}</Text>

                {detailContrat.typeContratPayment == 'auto' &&
                dayjs().isAfter(
                  dayjs(detailContrat.dateEcheance, 'DD/MM/YYYY'),
                  'day',
                ) ? null : (
                  <View
                    style={{
                      marginTop: 20,
                      alignItems: 'center',
                    }}>
                    <PrimaryButton
                      onPress={() => handleRenouvelerContrat()}
                      styleBtnTxt={buttonsStyles.btnValider}
                      styleBtnOuter={buttonsStyles.btnValiderOuter}
                      title={'Renouveler contrat'}
                      type="valider"
                    />
                  </View>
                )}
              </View>
            ) : null}
          </View>
          <View style={formsStyles.formContain}>
            {isLoading ? (
              <Loader />
            ) : (
              <View
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  flexDirection: 'row',
                }}>
                {/* RETRAITE */}
                {typeContrat === 'retraite' && (
                  <View style={styles.semiFlex}>
                    <Label title={title} type="mainTitle" />
                    <Label
                      type="titleGreen14"
                      title={'Nom et prénom(s) du Contractant: '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.nomPrenomContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Date de naissance du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.dateNaissanceContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Téléphone du Contractant :'}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.telephoneContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={"Nom et prénom(s) de l'Assuré : "}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.nomPrenomAssure}
                    />
                    <Label
                      type="titleGreen14"
                      title={"Adresse de l'Assuré : "}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.adresseAssure}
                    />
                    <Label
                      type="titleGreen14"
                      title={"Téléphone de l'Assuré : "}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.telephoneAssure}
                    />
                    <Label type="titleGreen14" title={"Email de l'Assuré : "} />
                    <Label
                      type="paragraph14"
                      title={detailContrat.emailAssure}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Agence ARO (gestionnaire du contrat) : '}
                    />
                    <Label type="paragraph14" title={detailContrat.agence} />
                    <Label
                      type="titleGreen14"
                      title={'Premier versement (cotisation) : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.premierVersement + ' MGA'}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Nom du bénéficiaire en cas de décès : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.beneficiaireCasDeces}
                    />
                  </View>
                )}

                {/* SCOLAIRE */}

                {typeContrat === 'scolaire' && (
                  <View style={styles.semiFlex}>
                    <Label title={title} type="mainTitle" />
                    <Label
                      type="titleGreen14"
                      title={'Nom et prénom(s) du Contractant: '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.nomPrenomContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Email du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.emailContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Téléphone du Contractant :'}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.telephoneContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={"Nom et prénom(s) de l'Elève assuré : "}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.nomPrenomEleveAssure}
                    />
                    <Label
                      type="titleGreen14"
                      title={"Date de naissance de l'Elève assuré : "}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.dateNaissanceEleveAssure}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Etablissement scolaire : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.etablissementScolaire}
                    />
                    <Label type="titleGreen14" title={'Année scolaire : '} />
                    <Label
                      type="paragraph14"
                      title={detailContrat.anneeScolaire}
                    />
                    <Label type="titleGreen14" title={'Adresse : '} />
                    <Label type="paragraph14" title={detailContrat.adresse} />
                    <Label
                      type="titleGreen14"
                      title={'Agence ARO (gestionnaire du contrat) : '}
                    />
                    <Label type="paragraph14" title={detailContrat.agence} />
                    <Label
                      type="titleGreen14"
                      title={'Prime TTC à payer (en Ariary) : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.primeTTC + ' MGA'}
                    />
                  </View>
                )}

                {/* RCVP */}
                {typeContrat === 'rcvp' && (
                  <View style={styles.semiFlex}>
                    <Label title={title} type="mainTitle" />
                    <Label
                      type="titleGreen14"
                      title={'Nom et prénom(s) du Contractant: '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.nomPrenomContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Date de naissance du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.dateNaissanceContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Email du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.emailContractant}
                    />

                    <Label
                      type="titleGreen14"
                      title={'Téléphone du Contractant :'}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.telephoneContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={"Nombre d'animaux domestiques : "}
                    />
                    <Label
                      type="paragraph14"
                      title={
                        detailContrat.nombreAnimauxDomestique &&
                        detailContrat.nombreAnimauxDomestique > 0
                          ? detailContrat.nombreAnimauxDomestique.toString()
                          : ''
                      }
                    />
                    <Label type="titleGreen14" title={'Adresse : '} />
                    <Label type="paragraph14" title={detailContrat.adresse} />
                    <Label
                      type="titleGreen14"
                      title={'Agence ARO (gestionnaire du contrat) : '}
                    />
                    <Label type="paragraph14" title={detailContrat.agence} />
                    <Label
                      type="titleGreen14"
                      title={'Prime TTC à payer (en Ariary) : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.primeTTC + ' MGA'}
                    />
                  </View>
                )}

                {/* AUTO */}
                {typeContrat === 'auto' && (
                  <View style={styles.semiFlex}>
                    <Label title={title} type="mainTitle" />

                    <Label
                      type="titleGreen14"
                      title={'Nom et prénom(s) du Contractant: '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.nomPrenomContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Date de naissance du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.dateNaissanceContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Email du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.emailContractant}
                    />
                    <Label type="titleGreen14" title={'Adresse : '} />
                    <Label type="paragraph14" title={detailContrat.adresse} />
                    <Label
                      type="titleGreen14"
                      title={'Agence ARO (gestionnaire du contrat) : '}
                    />
                    <Label type="paragraph14" title={detailContrat.agence} />
                    <Label
                      type="titleGreen14"
                      title={'N° immatriculation : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.immatriculation || 'Non disponible'}
                    />
                    <Label type="titleGreen14" title={'Marque et type : '} />
                    <Label
                      type="paragraph14"
                      title={`${detailContrat.carMarque || 'Non disponible'} ${
                        detailContrat.carType || ''
                      }`}
                    />
                  </View>
                )}

                {/* OTHERS RATTACHE */}
                {typeContrat === 'noType' && (
                  <View style={styles.semiFlex}>
                    <Label title={title} type="mainTitle" />
                    <Label
                      type="titleGreen14"
                      title={'Nom et prénom(s) du Contractant: '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.nomPrenomContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Date de naissance du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.dateNaissanceContractant}
                    />
                    <Label
                      type="titleGreen14"
                      title={'Email du Contractant : '}
                    />
                    <Label
                      type="paragraph14"
                      title={detailContrat.emailContractant}
                    />
                    <Label type="titleGreen14" title={'Adresse : '} />
                    <Label type="paragraph14" title={detailContrat.adresse} />
                    <Label
                      type="titleGreen14"
                      title={'Agence ARO (gestionnaire du contrat) : '}
                    />
                    <Label type="paragraph14" title={detailContrat.agence} />
                  </View>
                )}

                {/* VERSION */}
                <View style={styles.semiFlex}>
                  <View
                    style={[styles.semiFlexTwo, styles.wrapperInputPosition]}>
                    <DateTimePickerWeb
                      label="Date de version"
                      isDateContrat={true}
                      dateMin={new Date(dateDdMmYyToMmDdYy(dateMin, '/'))}
                      dateMax={new Date(dateDdMmYyToMmDdYy(dateMax, '/'))}
                      callBack={(value: any) => changeDate(value)}
                    />
                    <TouchableOpacity onPress={() => searchDate()}>
                      <Image
                        style={formsStyles.itemSearchIconeDetailContract}
                        source={require('../../../../ressources/images/Search.png')}
                      />
                    </TouchableOpacity>
                  </View>

                  <View style={styles.semiFlexTwo}>
                    <Label title="VERSION" type="mainTitle" />
                    <Label type="titleGreen14" title={'Numero Police: '} />
                    <Label
                      type="paragraph14"
                      title={version && version.numeroPolice}
                    />
                    <Label type="titleGreen14" title={"Date d'effet :"} />
                    <Label
                      type="paragraph14"
                      title={version && version.dateSouscription}
                    />
                    {typeContrat !== 'retraite' && (
                      <View>
                        <Label
                          type="titleGreen14"
                          title={"Date d'échéance : "}
                        />
                        <Label
                          type="paragraph14"
                          title={version && version.dateEcheance}
                        />
                      </View>
                    )}
                    {typeContrat === 'auto' &&
                      !detailContrat.statusImpression && (
                        <View>
                          <Label
                            type="titleGreen14"
                            title={"Code d'impression à usage unique :"}
                          />
                          <Text style={styles.codeImpression}>
                            {detailContrat.codeImpression || 'Non disponible'}
                          </Text>
                        </View>
                      )}
                  </View>
                </View>
              </View>
            )}
            <View style={{marginTop: 30}}>
              <ProduitItem
                data={display}
                idContrat={numeroPolice}
                isDetailContrat={true}
                typeContrat={typeContrat}
                agenceAro={agenceAro}
              />
            </View>
            <View style={styles.btnPayment}>
              {typeContrat === 'retraite' ? (
                <PrimaryButton
                  onPress={goToPayment}
                  styleBtnTxt={{
                    ...buttonsStyles.btnValider,
                    ...styles.btnCotisation,
                  }}
                  styleBtnOuter={buttonsStyles.btnValiderOuter}
                  title="Payer cotisation"
                  type="valider"
                />
              ) : null}
            </View>
            <Modal
              animationType="slide"
              transparent={true}
              visible={showRenouvellement}>
              <View style={styles.contratRattacheModal}>
                <View
                  style={[
                    styles.contratRattacheWrapper,
                    typeContrat == 'auto' && {
                      maxHeight: '95vh' as DimensionValue,
                    },
                  ]}>
                  <ContratRattacheForm
                    show={showRenouvellement}
                    onClose={() => setShowRenouvellement(false)}
                    onSubmit={() => onSubmitContratForm()}
                    detailsContrat={detailContrat}
                  />
                </View>
              </View>
            </Modal>
            {showErrorModal && (
              <ConfirmationModal
                title="Erreur"
                content={errorMessage}
                btn1="OK"
                handleBtn1={() => setShowErrorModal(false)}
              />
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export const DetailContrat: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailContratScreen);
